export default __webpack_public_path__ + "media/b5b13b8a3f6bfe60f8a739c870182a8e4be7189fe8c7fe2c36a629fca73eb00d.svg";